<template>
  <div class="space-y-6">
    <div class="grid grid-cols-2 gap-6 xl:pr-24">
      <div
        class="col-span-full flex flex-col space-y-2 md:col-span-1"
        v-if="cardMode"
      >
        <h3 class="text-2xl">Dados do cartão</h3>
        <div class="space-y-4 rounded-lg bg-ontick-graphite-500 p-4">
          <div class="grid grid-cols-3 gap-4">
            <ontick-input-component
              label="Nome impresso no cartão"
              placeholder="Nome impresso no cartão"
              name="card_name"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full"
              v-validate="'required|alpha'"
              v-model="card.name"
              :error="errors.first('card_name')"
            />
            <ontick-input-component
              label="Número do cartão"
              placeholder="1234 5678 9123 4567"
              name="card_number"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full"
              v-mask="'#### #### #### ####'"
              v-validate="'required'"
              :error="errors.first('card_number')"
              v-model="card.number"
            />

            <ontick-select-component
              label="Mês"
              bg="bg-ontick-steel-500"
              :options="expirationMonths"
              placeholder="Selecione"
              shadow="shadow-none"
              noBorder
              name="expirationMonth"
              v-model="card.expirationMonth"
              v-validate="'required'"
              :error="errors.first('expirationMonth')"
              class="col-span-full xl:col-span-1"
            />
            <ontick-select-component
              label="Ano"
              bg="bg-ontick-steel-500"
              :options="expirationYears()"
              placeholder="Selecione"
              shadow="shadow-none"
              noBorder
              name="expirationYear"
              v-model="card.expirationYear"
              v-validate="'required'"
              :error="errors.first('expirationYear')"
              class="col-span-full xl:col-span-1"
            />
            <ontick-input-component
              label="CVV"
              placeholder="123"
              name="card_cvv"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full xl:col-span-1"
              v-mask="'###'"
              v-validate="'required'"
              :error="errors.first('card_cvv')"
              v-model="card.cvv"
            />
          </div>
        </div>
      </div>
      <div class="col-span-full flex flex-col space-y-2 md:col-span-1" v-else>
        <h3 class="text-2xl">Endereço de cobrança</h3>
        <div class="space-y-4 rounded-lg bg-ontick-graphite-500 p-4">
          <div class="grid grid-cols-6 gap-4">
            <div class="relative col-span-3">
              <ontick-input-component
                label="CEP"
                placeholder="04538-132"
                bg="bg-ontick-steel-500"
                shadow="shadow-none"
                noBorder
                v-mask="'#####-###'"
                class=""
                name="cep"
                v-model="address.cep"
                @keyup.native="getCep(address.cep)"
                v-validate="'required'"
                :error="errors.first('cep')"
              />
              <i
                v-html="$icons.loading"
                class="absolute bottom-2 right-2"
                v-if="addressIsLoading"
              ></i>
            </div>
            <div class="col-span-6 md:col-span-3 lg:col-span-2 xl:col-span-3">
              <p class="text-xs font-medium text-white">País</p>
              <v-select
                v-model="address.country"
                :options="countries"
                :reduce="(country) => country.code"
                label="country"
                class="country-register mt-1 h-9 rounded-md bg-ontick-steel-500"
              />
            </div>
            <ontick-input-component
              label="Logradouro"
              placeholder="Avenida Brigadeiro Faria Lima"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full"
              v-model="address.address"
              name="address"
              v-validate="'required'"
              :error="errors.first('address')"
            />
            <ontick-input-component
              label="Número"
              type="number"
              placeholder="1001"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full xl:col-span-2"
              v-model="address.number"
              name="AddressNumber"
              v-validate="'required'"
              :error="errors.first('AddressNumber')"
            />
            <ontick-input-component
              label="Complemento"
              placeholder="Ex.: Apto. 101"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full xl:col-span-4"
              v-model="address.complement"
              name="complement"
              :error="errors.first('complement')"
            />
            <ontick-input-component
              label="Bairro"
              placeholder="Itaim Bibi"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full xl:col-span-2"
              v-model="address.neighborhood"
              name="neighborhood"
              v-validate="'required'"
              :error="errors.first('neighborhood')"
            />
            <ontick-input-component
              label="Cidade"
              placeholder="São Paulo"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full xl:col-span-2"
              v-model="address.city"
              name="city"
              v-validate="'required'"
              :error="errors.first('city')"
            />
            <ontick-input-component
              label="UF"
              placeholder="SP"
              bg="bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              class="col-span-full xl:col-span-2"
              v-mask="'AA'"
              v-model="address.state"
              name="state"
              v-validate="'required'"
              :error="errors.first('state')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full justify-between xl:pr-24">
      <ontick-button-component color="cinza" @click.native="$emit('exit')">
        <i v-html="$icons.chevron_left"></i>
        <span>Voltar</span>
      </ontick-button-component>
      <ontick-button-component @click.native="sendData">
        <i v-html="$icons.loading" v-if="isLoading"></i>
        <span v-else>Confirmar</span>
      </ontick-button-component>
    </div>
  </div>
</template>

<script>
import OntickButtonComponent from "../../../shared/components/basic/ontick-button.component.vue";
import OntickInputComponent from "../../../shared/components/basic/ontick-input.component.vue";
import vSelect from "vue-select";

import axios from "axios";
import OntickSelectComponent from "../../../shared/components/basic/ontick-select.component.vue";
import { Encrypt } from "@/app/shared/utils/encrypt";
import { mapState } from "vuex";
export default {
  components: {
    OntickInputComponent,
    OntickButtonComponent,
    vSelect,
    OntickSelectComponent,
  },
  props: {
    cardMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      card: {
        name: "",
        number: "",
        expirationMonth: "",
        expirationYear: "",
        cvv: "",
      },
      address: {
        country: "BR",
        cep: "",
        address: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
      },
      countries: [],
      addressIsLoading: false,
      isLoading: false,
      expirationMonths: [
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
      ],
    };
  },
  computed: {
    ...mapState({ accountTypes: (state) => state.accountTypes }),
    cardType() {
      const number = this.card.number.replace(/\s+/g, "");
      if (number.match(/^4(026|17500|405|508|844|91[37])/))
        return "Visa Electron";
      if (number.match(/^4\d{12}(\d{3})?$/)) return "Visa";
      if (
        number.match(
          /^((509091)|(636368)|(636297)|(504175)|(438935)|(40117[8-9])|(45763[1-2])|(457393)|(431274)|(50990[0-2])|(5099[7-9][0-9])|(50996[4-9])|(509[1-8][0-9][0-9])|(5090(0[0-2]|0[4-9]|1[2-9]|[24589][0-9]|3[1-9]|6[0-46-9]|7[0-24-9]))|(5067(0[0-24-8]|1[0-24-9]|2[014-9]|3[0-379]|4[0-9]|5[0-3]|6[0-5]|7[0-8]))|(6504(0[5-9]|1[0-9]|2[0-9]|3[0-9]))|(6504(8[5-9]|9[0-9])|6505(0[0-9]|1[0-9]|2[0-9]|3[0-8]))|(6505(4[1-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-8]))|(6507(0[0-9]|1[0-8]))|(65072[0-7])|(6509(0[1-9]|1[0-9]|20))|(6516(5[2-9]|6[0-9]|7[0-9]))|(6550(0[0-9]|1[0-9]))|(6550(2[1-9]|3[0-9]|4[0-9]|5[0-8])))/
        )
      )
        return "Elo";
      if (number.match(/^3[47]\d{13}$/)) return "Amex";
      if (number.match(/^(5[1-5]\d{4}|677189)\d{10}$/)) return "Mastercard";
      if (number.match(/^6(?:011|5[0-9]{2})[0-9]{12}$/)) return "Discover";
      if (number.match(/^3(0[0-5]|[68]\d)\d{11,16}/)) return "Dinersclub";

      if (number.match(/(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/))
        return "Maestro";
      return "";
    },
    encryptKey() {
      return (
        this.accountTypes.selectedAccount.user_code.repeat(5) +
        this.accountTypes.selectedAccount.user_code.substr(0, 2)
      );
    },
  },
  methods: {
    expirationYears() {
      let date = new Date();
      let year = date.getFullYear();
      let arr = [];
      for (let i = year; i < year + 10; i++) {
        arr.push({
          label: i,
          value: i,
        });
      }
      return arr;
    },
    sendData() {
      this.$validator
        .validate()
        .then((valid) => {
          if (valid) {
            this.isLoading = true;
            this.$api
              .get(this.$endpoint.PAYMENTS_USER_STATUS)
              .then(() => {
                if (this.cardMode) {
                  this.saveCard();
                } else {
                  this.saveAddress();
                }
              })
              .catch((err) => {
                console.error(err);
                this.$swal("Erro", err.data.msg, "error");
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveCard() {
      let params = {
        card_number: this.card.number.replaceAll(" ", ""),
        card_holder_name: this.card.name,
        card_expire_month: this.card.expirationMonth,
        card_expire_year: this.card.expirationYear,
        card_cvv: this.card.cvv,
        card_brand: this.cardType,
      };
      return this.$api
        .post(this.$endpoint.CARD_SAVE, {
          data: Encrypt(JSON.stringify(params), this.encryptKey),
        })
        .then((res) => {
          console.log("save card", res.data);
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
            timer: 3000,
            timerProgressBar: true,
          }).then(() => {
            this.$emit("exit");
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    saveAddress() {
      return this.$api
        .post(this.$endpoint.ADDRESS_SAVE, {
          street: this.address.address,
          street_number: this.address.number,
          neighborhood: this.address.neighborhood,
          ...(this.address.complement && {
            address_2: this.address.complement,
          }),
          city: this.address.city,
          state: this.address.state,
          country: this.address.country,
          zip_code: this.address.cep.replace("-", ""),
        })
        .then((res) => {
          console.log("save address", res.data);
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            icon: "success",
            iconHtml: this.$icons.swal_success,
            timer: 3000,
            timerProgressBar: true,
          }).then(() => {
            this.$emit("exit");
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getCountries() {
      this.$api
        .get(this.$endpoint.COUNTRIES_LIST)
        .then((res) => {
          this.countries = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCep(zipCode) {
      if (zipCode.trim() == "" || zipCode.length < 8) {
        return;
      } else {
        if (/^[0-9]{5}-[0-9]{3}$/.test(zipCode)) {
          this.addressIsLoading = true;
          let new_code = "";
          new_code = zipCode.replace("-", "");

          axios
            .get(`https://viacep.com.br/ws/${new_code}/json/`)
            .then((res) => {
              this.address.address = res.data.logradouro;
              this.address.neighborhood = res.data.bairro;
              this.address.city = res.data.localidade;
              this.address.state = res.data.uf;
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.addressIsLoading = false;
            });
        }
      }
    },
  },

  created() {
    this.getCountries();
  },
};
</script>

<style>
.country-register .vs__search {
  @apply !bg-transparent;
}
.country-register .vs__clear,
.country-register .vs__open-indicator {
  fill: rgba(108, 115, 127);
}
</style>
